import React from 'react';
import { useStateSelector } from 'src/redux';

interface Props {
  isActive?: boolean;
}

export const ContentMgt: React.FC<Props> = ({ isActive }) => {
  const colors = useStateSelector(({ theme }) => theme.colors);
  const fill = isActive ? 'url(#content-mgt-icon-gradient)' : colors.cflowerBlue;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
      <path
        d="M10.5 1.2 19 5.7 10.5 10.2 2 5.7 10.5 1.2Z"
        fill={fill}
      />
      <path
        d="M2 8.35 10.5 12.85 19 8.35V11.15L10.5 15.65 2 11.15V8.35Z"
        fill={fill}
        opacity="0.86"
      />
      <path
        d="M2 13.05 10.5 17.55 19 13.05V15.85L10.5 20.35 2 15.85V13.05Z"
        fill={fill}
        opacity="0.72"
        transform="translate(0 -1.35)"
      />
      <defs>
        <linearGradient id="content-mgt-icon-gradient" x1="2" y1="1" x2="19" y2="20" gradientUnits="userSpaceOnUse">
          <stop stopColor={colors.gp1} />
          <stop offset="1" stopColor={colors.gp2} />
        </linearGradient>
      </defs>
    </svg>
  );
};
